import Ph180TabBar from "../Ph180TabBar";
import MenuSheet from "../MenuSheet";
import { UnizoLogo } from "../UnizoLogo";
import NotificationBellButton from "./NotificationBellButton";
import { ROUTE_TOP } from "@/utils/const";
import type { Chrome } from "./ChromeContext";

/**
 * PRODUCT_DEV-748: Unizo ビルドの外枠。`router.tsx` の RootLayout が注入する。
 * Minizo 側は `components/minizo/minizoChrome.ts`。
 */
export const unizoChrome: Chrome = {
  TabBar: Ph180TabBar,
  MenuSheet,
  Logo: UnizoLogo,
  homePath: ROUTE_TOP,
  homeLabel: "記録一覧",
  topLabel: "記録一覧",
  NotificationBell: NotificationBellButton,
};
